import React, { useState } from "react";
import { Col, Form, Row, Tab, Tabs, Modal, Button, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import TableTemplate from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import ReactLoading from "react-loading";
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTodayDateISO,
    selectDropdownStyle
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import trash from "../../../Assets/Images/trash.png";
import * as XLSX from "xlsx";

import { getWastage, updateWastageStatus } from "../../../Helpers/apiCalls/Reports/DailyWastageApi";
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import { createEmployeeDeduction, deleteEmployeeDeduction } from './../../../Helpers/apiCalls/Reports/DailySalesApi';
import { getAllShortageDeduction, createShortageDeduction, deleteShortageDeduction } from './../../../Helpers/apiCalls/Reports/ShortageDeductionApi';
import { validateEmployeeDeduction } from './../../../Helpers/Validation/Employees/EmployeeDeductions';
import InputError from './../../../Components/InputError/InputError';
import Footer from "../../../Components/Footer/Footer";

export default function EmployeeDeductions() {
    const { id, branch_name, date } = useParams();
    const { state } = useLocation();
    
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    
    const today = new Date();
    const ago = new Date();
    ago.setDate(ago.getDate() - 30);

    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        branch_id: id !== "0" ? id : "",
        date_from: state?.date ? new Date(state.date) : ago,
        date_to: state?.date ? new Date(state.date) : today,
        source: state !== null ? state.source !== "sales" ? state.source : "inventory_variance" : "",
    })
    const [showLoader, setShowLoader] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [branches, setBranches] = useState([]);
    const [allData, setAllData] = useState([]);
    const [totalBalance, setTotalBalance] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [branchName, setBranchName] = useState("");
    const [wastageDate, setWastageDate] = useState("");
    const [title, setTitle] = useState("");
    const [selectedRow, setSelectedRow] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [excelData, setExcelData] = useState([]);
    const [addDetails, setAddDetails] = useState([{
        employee_id: state?.cashier ? state.cashier.id : "",
        employee_id_value: state?.cashier ? {
                value: state.cashier.id,
                label: state.cashier.name,
            } : "",
        amount: "",
    }])
    
    const [isError, setIsError] = useState({
        list: false,
        employee_id: false,
        amount: false,
    });

     /* add modal handler */
     var logic = id !== "0" ? true : false
     const [showAddModal, setShowAddModal] = useState(logic);
     const handleShowAddModal = (title) => {
        setTitle(title)
        setShowAddModal(true);
    }
     const handleCloseAddModal = () => setShowAddModal(false);

     /* delete modal handler */
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const handleShowDeleteModal = () => setShowDeleteModal(true);
     const handleCloseDeleteModal = () => setShowDeleteModal(false); 

    const xlsxHeaders =  [
        "DATE",
        "EMPLOYEE NAME",
        "SOURCE ID",
        "SOURCE",
        "BRANCH",
        "AMOUNT",
        "BALANCE",
        "STATUS",
        "REMARKS",
    ]
    const excelHeaders = [
        { label: "DATE", key: "added_on" },
        { label: "EMPLOYEE NAME", key: "employee_name" },
        { label: "SOURCE", key: "source" },
        { label: "CHARGE AMOUNT", key: "amount" },
        { label: "BALANCE", key: "balance" },
        { label: "STATUS", key: "status" },
    ];

    const dummy = [
        {
            id: "1",
            item: "straw",
            quantity: "500",
            unit: "pc",
            reason: "asdfasdf",
        },
    ]
    
    function AddEmployeeBtn() {
        const newProduct = { employee_id: "", amount: "" };
        setAddDetails((prev) => [...prev, newProduct]);
    }

    function handleRemoveEmployee(id) {
        const rowId = id;
        const newList = [...addDetails];
        newList.splice(rowId, 1);
        setAddDetails(newList);
    }
    
    function handleEmployeeChange(e, index, type) {
        if(type === "select") {
            const list = [...addDetails];
            list[index][e.for] = e.value;
            list[index][e.select_value] = {
                for: e.for,
                label: e.label,
                value: e.value,
            };
            setAddDetails(list);
        } else {
            const { name, value } = e.target;
            const list = [...addDetails];
            if(name === "amount") {
                if(value === "" || parseFloat(value) <= 0) {
                    toast.error("Please enter amount greater than 0", {
                        style: toastStyle(),
                    });
                }
            }
            list[index][name] = value;
            setAddDetails(list);
        }
    }

    function handleSelectChange(e, row) {
        setSelectedRow(row);

        if (e.target.value === "delete") {
            handleShowDeleteModal()
        }
    }

    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                { (accountType === "admin" || accountType === "operations_manager") ? (
                    <option value="delete" className="color-options">
                        Delete
                    </option>
                    ): null
                }
            </Form.Select>
        );
    }

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    async function fetchBranches() {
        setShowLoader(true);
        setBranches([])
        const response = await getAllBranches();
        if (response.error) {
        } else {
            var allBranches = response.data.data.data
            .filter((data) => {
                return data.is_franchise === "0"
            })
            .map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            setBranches([{label: "All Branches", value:""}, ...allBranches]);
        }
        setShowLoader(false);
        
        // if(filterConfig.shop === "mango") {
        //     const response = await getAllBranches();
        //     if (response.error) {
        //     } else {
        //         var allBranches = response.data.data.data
        //         .filter((data) => {
        //             return data.is_franchise === "0"
        //         })
        //         .map((data) => {
        //             var branch = data;
        //             branch.label = data.name
        //             branch.value = data.id
        //             return branch;
        //         });
        //         setBranches([{label: "All Branches", value:""}, ...allBranches]);
        //     }
        //     setShowLoader(false);
        // } else if(filterConfig.shop === "potato") {
        //     const response = await getAllBranchesPotato();
        //     if (response.error) {
        //     } else {
        //         var allBranches = response.data.data
        //         .filter((data) => {
        //             return data.is_franchise === "0"
        //         })
        //         .map((data) => {
        //             var branch = data;
        //             branch.label = data.name
        //             branch.value = data.id
        //             return branch;
        //         });
        //         setBranches([{label: "All Branches", value:""}, ...allBranches]);
        //     }
        //     setShowLoader(false);
        // }
    }

    async function fetchEmployees() {

        const response = await getAllEmployees();
        if (response.error) {
            setEmployees([])
        } else {
            let result = response.data.data.map((data) => {
                var employee = data;
                employee.for = "employee_id"
                employee.select_value = "employee_id_value"
                employee.label = data.first_name + " " + data.last_name;
                employee.value = data.id;
                return employee;
            });
            setEmployees([{label: "All Employees", value: ""}, ...result]);
        }
    }
    

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setExcelData([])
        setTotalAmount(0);
        setTotalBalance(0);
        const response = await getAllShortageDeduction(filterConfig);
        if (response.error) {
            setTotalAmount(0);
            setTotalBalance(0);
        } else {
            setBranchName(response.data.data[0].branch_name);
            setWastageDate(response.data.data[0].wastage_date);
            var allData = response.data.data.map((data) => {
                var info = data;
                var stat = data.source.split("_")
                info.source = stat.length < 2 ? data.source : stat[0] + " " + stat[1]
                info.status = data.status === "created" ? "unpaid" : data.status
                info.added_on = Moment(data.added_on).format("MM/DD/YYYY")
                info.date = Moment(data.date).format("MM/DD/YYYY")
                info.amount = numberFormat(data.amount)
                info.balance = numberFormat(data.balance)
                return info;
            });
            setAllData(allData)

            var excel = allData.map((bill) => {
                var info = {};
                info.date = bill.date
                info.employee_name = bill.employee_name
                info.source_id = bill.source_id
                info.source = bill.source
                info.branch_name = bill.branch_name
                info.amount = bill.amount
                info.balance = bill.balance
                info.status = bill.status
                info.remarks = bill.remarks
                return info;
            });
            setExcelData(excel)
            
            var charge = response.data.summary? response.data.summary.total_charges : "0";
            var balance = response.data.summary? response.data.summary.total_balance : "0";
            setTotalAmount(charge);
            setTotalBalance(balance);
        }
        setShowLoader(false);
    }

    async function handleCreateEmployeeDeduction() {
        var source_id = ""
        var date = ""
        if(state.source === "wastage") {
            source_id = state.details.id;
            date = state.details.added_on;
        } else {
            source_id = state.daily_sale_id;
            state.source = title === "Cash Variance" ? "cash_variance" : "inventory_variance";
            date = state.date;
        }
        if (validateEmployeeDeduction(addDetails, setIsError)) {
            setIsClicked(true);
            const response = await createShortageDeduction(source_id, state.source, date, addDetails);
            
            if (response.error) {
                toast.error(response.error.response.data.messages.error, {
                    style: toastStyle(),
                });
            } else {
                toast.success("Successfully added employee deduction!", {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    // navigate(-1)
                    // refreshPage()
                    handleCloseAddModal()
                    fetchData();
                }, 1000);
            }
        } else {
            toast.error("Please fill in all fields", {
                style: toastStyle(),
            });
        }
    }

    async function handleDeleteDeduction() {
        setIsClicked(true);
        const response = await deleteShortageDeduction([{id: selectedRow.id}]);
        if (response.data) {
            toast.success("Employee Deduction Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            toast.error("Error Deleting Employee Deduction", {
                style: toastStyle(),
            });
        }
    }

    function DocBtn(row) {
        return (
            <span
                className="me-4 align-middle ps-label blue"
                onClick={() =>
                    handleViewDoc(row.source_id, row.source, row)
                } 
            >
                {row.source_id}
            </span>
        );
    }
    function handleViewDoc(id, source, row) {
        if (source === "wastage") {
            window.open("/dailywastage/view/" + row.wastage_id);
        } else if (source === "inventory variance") {
            window.open("/dailysales/view/" + row.branch_id + "/" + Moment(row.date).format("MM-DD-YYYY"));
        }
    }
    
    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "EmployeeDeductions.xlsx", { compression: true });
    }

    React.useEffect(() => {
        fetchEmployees()
        fetchBranches()
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [filterConfig]);

    

    function renderTable() {
        return (
            <Table>
                <thead>
                    <tr>
                        <th>Employee</th>
                        <th>Amount</th>
                        <th>Remarks</th>
                        {/* <th>No. of Times Payable</th> */}
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {addDetails.map((employee, index) => {
                        return (
                            <tr>
                                <td>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select Employee..."
                                        value={employee.employee_id_value}
                                        options={employees}
                                        onChange={(e) => handleEmployeeChange(e, index, "select")}
                                    />
                                    <InputError
                                        isValid={isError.employee_id}
                                        message={"Employee is required"}
                                    />
                                </td>
                                <td>
                                    <Form.Control
                                        type="number"
                                        min={1}
                                        name="amount"
                                        className="nc-modal-custom-text"
                                        value={employee.amount}
                                        onChange={(e) => handleEmployeeChange(e, index, "text")}
                                    />
                                    <InputError
                                        isValid={isError.amount}
                                        message={"Amount is required and should be greater than 0"}
                                    />
                                </td>
                                <td>
                                    <Form.Control
                                        type="text"
                                        name="remarks"
                                        className="nc-modal-custom-text"
                                        value={employee.remarks}
                                        onChange={(e) => handleEmployeeChange(e, index, "text")}
                                    />
                                </td>
                                {/* <td>
                                    <Form.Control
                                        type="times_payable"
                                        name="times_payable"
                                        className="nc-modal-custom-text"
                                        value={employee.times_payable}
                                        onChange={(e) => handleEmployeeChange(e, index, "text")}
                                    />
                                </td> */}
                                <td>
                                    <div className="align-middle">
                                        <img
                                            src={trash}
                                            alt="delete"
                                            onClick={() =>
                                                handleRemoveEmployee(index)
                                            }
                                            className="cursor-pointer"
                                        />
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PAYROLL"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                {
                    state?.source === "wastage" && id !== "0" && (
                        <>
                            <Row className="mb-4">
                                <Col xs={6}>
                                    <h1 className="page-subtitle"> EMPLOYEE DEDUCTIONS </h1>
                                    <h5 className="page-subtitle"> {branch_name} </h5>
                                    <h6 className="page-subtitle"> {Moment(date).format("MMM DD, YYYY")} </h6>
                                </Col>
                                <Col className="d-flex justify-content-end">
                                    <button
                                        className="add-btn"
                                        onClick={(e) => handleShowAddModal("Wastage")}
                                    >
                                        Add
                                    </button>
                                </Col>
                            </Row>
                        </>
                    )
                }
                {
                    state?.source === "sales" && id !== "0" && (
                        <>
                            <Row className="mb-4">
                                <Col xs={6}>
                                    <h1 className="page-subtitle"> EMPLOYEE DEDUCTIONS </h1>
                                    <h5 className="page-subtitle"> {branch_name} </h5>
                                    <h6 className="page-subtitle"> {Moment(date).format("MMM DD, YYYY")} </h6>
                                </Col>
                                <Col className="d-flex justify-content-end">
                                    <button
                                        className="add-btn"
                                        onClick={(e) => handleShowAddModal("Variance")}
                                    >
                                        Add
                                    </button>
                                    {/* <div className="my-2 PO-filters d-flex">
                                        <Form.Select
                                            name="add-type"
                                            className="date-filter me-3 add-type"
                                            onChange={(e) => handleShowAddModal(e.target.value)}
                                        >
                                            <option value="" hidden selected>
                                                Add
                                            </option>
                                            <option value="Cash Variance">Cash Variance</option>
                                            <option value="Inventory Variance">Inventory Variance</option>
                                        </Form.Select>
                                    </div> */}
                                </Col>
                            </Row>
                        </>
                    )
                }
                {
                    id === "0" && (
                        <>
                            <Row className="mb-4">
                                <Col xs={12} lg={7}>
                                    <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> EMPLOYEE DEDUCTIONS </h1>
                                </Col>
                            </Row>
                        </>
                    )
                }

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Employee"
                            styles={selectDropdownStyle}
                            // value={branch}
                            options={employees}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "employee_id": e.value };
                                });}}
                        />
                        {/* <Select
                            className="dropsearch-filter px-0 py-0 me-2"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={{
                                control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                borderRadius: "7px",
                                border: "0px",
                                minHeight: "20px",
                                maxHeight: "35px",
                                }),
                                input: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: state.isSelected? "white": "white",
                                    
                                }),
                                dropdownIndicator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                singleValue: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                placeholder: (baseStyles, state) => ({
                                    ...baseStyles,
                                    color: "white"
                                    
                                }),
                                
                            }}
                            // value={branch}
                            options={branches}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "branch_id": e.value };
                                });}}
                        /> */}
                        </Col>
                        <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                        <Form.Select
                            name="source"
                            className="date-filter force-width w-full"
                            defaultValue={filterConfig.source}
                            onChange={(e) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, source: e.target.value };
                                });
                            }}
                        >
                            <option value="" selected>
                                All Sources
                            </option>
                            <option value="wastage" >
                                Wastage
                            </option>
                            <option value="inventory_variance" >
                               Inventory Variance
                            </option>
                         
                        </Form.Select>
                        </Col>
                        <Col xs={12} lg={2} className="mb-2 mb-lg-0">
                        <Form.Select
                            name="status"
                            className="date-filter force-width w-full"
                            defaultValue={filterConfig.status}
                            onChange={(e) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, status: e.target.value };
                                });
                            }}
                        >
                            <option value="" selected>
                                All Status
                            </option>
                            <option value="created" >
                                Unpaid
                            </option>
                            <option value="paid" >
                                Settled
                            </option>
                            <option value="unsettled" >
                                Unsettled
                            </option>
                            
                        </Form.Select>
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={ago}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={today}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className=" PO-filters d-flex justify-content-center">
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Charge Amount: {numberFormat(totalAmount)}
                        </span>
                        <span className="me-4 ml-4 mt-2 ps-label">
                            Total Balance: {numberFormat(totalBalance)}
                        </span>
                    </div>

                    <div className="below">
                        {/* table */}
                        <TableTemplate
                            tableHeaders={[
                                "DATE",
                                "EMPLOYEE NAME",
                                "SOURCE ID",
                                "SOURCE",
                                "BRANCH",
                                "AMOUNT",
                                "BALANCE",
                                "STATUS",
                                "REMARKS",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "date",
                                "employee_name",
                                "source_id",
                                "source",
                                "branch_name",
                                "amount",
                                "balance",
                                "status",
                                "remarks",
                            ]}
                            tableData={allData}
                            showLoader={showLoader}
                            ContractBtn={(row) => DocBtn(row)}
                            ActionBtn={(row) => ActionBtn(row)}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
                {
                    id !== "0" && (
                        <>
                            <div className="d-flex justify-content-end my-4 pb-5 ">
                                <button
                                    className="button-secondary me-3"
                                    onClick={() => navigate(-1)}
                                >
                                    Back
                                </button>
                            </div>
                        </>
                    )
                }
                <div className="mb-3" />
                <Row>
                    <Col lg={10} className="mt-3 mt-lg-0"></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                </Col>
                </Row>
            </div>
            
            <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="employee deduction"
                onDelete={handleDeleteDeduction}
                isClicked={isClicked}
            />
            
            <Modal show={showAddModal} onHide={()=>handleCloseAddModal()} size="lg" centered>
                <Modal.Header closeButton/>
                <Modal.Body className='pt-2'>
                    <p className="custom-modal-body-title">
                        {title} 
                    </p>
                    {
                        state?.total_variance && (
                            <p className={parseFloat(state?.total_variance) > 0 ? "custom-modal-body text-end green pe-4 mb-0" : "custom-modal-body text-end red pe-4 mb-0"}>
                                {"Total Variance: " + state?.total_variance } 
                            </p>
                        )
                    }
                    <div className=' p-3'>
                        <Row className="nc-modal-custom-row">
                            <div className="edit-purchased-items">
                                {addDetails.length === 0 ? (
                                    <span>No Employees Added!</span>
                                ) : (
                                    renderTable()
                                )}
                            </div>
                            <InputError
                                isValid={isError.list}
                                message={"Employee is required"}
                            />
                        </Row>
                        
                        <Row className="pt-3 PO-add-item">
                            <Button type="button" onClick={() => AddEmployeeBtn()}>
                                Add Employee
                            </Button>
                        </Row>
                    </div>
                    <div className='d-flex justify-content-end my-4'>
                        <button
                            className="button-secondary me-2"
                            onClick={()=>handleCloseAddModal()}
                        >
                            Cancel
                        </button>
                        {isClicked === true && (
                            <div className="button-primary d-flex justify-content-center">
                                <ReactLoading
                                    type="bubbles"
                                    color="#FFFFFF"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        )}
                        {isClicked !== true && (
                            <button
                                className="button-primary"
                                onClick={()=> handleCreateEmployeeDeduction()}
                            >
                                Save
                            </button>
                        )}
                    </div>
                
                </Modal.Body>
            </Modal>
            <Footer/>
        </div>
    );
}
